import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { useNegotiation } from "../contexts/NegotiationContext";
//import Termo from "./Termo";
import TermoNovacao from "./TermoNovacao";

function TermoDialog({ close, aceiteTermo }) {
  const { pdf } = useNegotiation();
  const [checkedTermo, setCheckedTermo] = useState(false);

  const TermoFooter = (
    <div className="grid gap-[1vh] font-lato justify-center">
      <div className="loginCheckbox" style={{ textAlign: "center" }}>
        <Checkbox inputId="binary" checked={checkedTermo} onChange={(e) => setCheckedTermo(e.checked)} />
        <label htmlFor="binary">Concordo com o presente instrumento particular de renegociação de dívida</label>
      </div>
      <div className="continueButton w-full grid">
        <Button
          className="continueButton"
          label="Continuar"
          onClick={() => {
            aceiteTermo();
            close();
          }}
          disabled={!checkedTermo || pdf === ""}
        ></Button>
        {/* <button className='bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
            hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
            hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
            disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
            text-[2.5vh] font-lato font-bold disabled:bg-[#001d74]/70 rounded-md mt-6' 
            onClick={()=>aceiteTermo()} 
            disabled={!checkedTermo}
            type="button"
            >Continuar</button> */}
      </div>
    </div>
  );

  return (
    <Dialog
      visible
      draggable={false}
      maximizable
      onHide={() => close()}
      header="Instrumento Particular de Negociação de Dívida"
      style={{
        width: window.innerWidth > 820 ? "60vw" : "100vw",
        minHeigth: "30vh",
        minWidth: "20vh",
        textAlign: "center",
        // borderRadius: '30px',
        // padding: '10px'
      }}
      className="boletosDialog"
      footer={TermoFooter}
    >
      {/* <Termo/> */}
      <TermoNovacao />
    </Dialog>
  );
}

export default TermoDialog;
